/* eslint-disable no-unused-vars */

import SectionContainer from '@components/section-container';
import style from '../../workorder.module.scss';

const AdditionalDataNotDownloadSubSection = () => {
  return (
    <div>
      <SectionContainer
        text={'Additional data not downloaded'}
        subSection
        headerClassName={`${style.utSectionOfPhotos}`}
      >
        <div className={style.notDownloadData}>
          <p>
            This equipment has existing UT data that was not downloaded, likely because you were
            offline when the form was opened.
          </p>
          <div className="mt-2"></div>

          <p>You can still submit the inspection by creating new CMLs below.</p>
        </div>
      </SectionContainer>
    </div>
  );
};

export default AdditionalDataNotDownloadSubSection;
